import * as _ from 'underscore';
import { callViaApiService, UploadBundlesQueryParams, UploadBundlesResponse } from '../api/UploadBundles';
import { UploadBundlesStartAction } from '../actions/UploadBundlesActions';

function uploadBundlesRequest(action: UploadBundlesStartAction): Promise<UploadBundlesResponse> {
  const requestBodyStr = getRequestBody(action.data.projectName, action.data.projectDescription, action.data.contentPermissions);
  const requestBodyBlob = new Blob([requestBodyStr]);
  const queryParams = getQueryParam(action);
  const headers = { 'Content-Type': 'application/json' };

  return callViaApiService(requestBodyBlob, headers, queryParams) as Promise<UploadBundlesResponse>;
}

function getRequestBody(name: string, description: string, contentPermissions: string) {
  const data = {
    project: { name, description, contentPermissions }
  };
  const dataStr = JSON.stringify(data);

  return dataStr;
}

function getQueryParam(action: UploadBundlesStartAction): UploadBundlesQueryParams {
  return {
    'bundleIds': action.data.bundleIds,
    'oauthId': action.oauthId,
  };
}

export default {
  uploadBundlesRequest,
};

// For unit testing purposes
export const TestUploadBundlesRequestHelper = {
  uploadBundlesRequest,
  getQueryParam,
  getRequestBody,
};
